module.exports = __webpack_public_path__ + "static/media/wood-stove.b9c9debd.png";